import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { translateMultiplet } from 'nmr-processing';
import FormikInput from '../../../../elements/formik/FormikInput';
const style = {
    input: {
        width: '60px',
        height: '30px',
    },
    inputWrapper: {
        borderWidth: 0,
        margin: '0 5px',
    },
};
export function DeltaInput({ signal, index }) {
    return (_jsxs("div", { style: { display: 'flex', alignItems: 'center' }, children: [_jsx("span", { children: "\uD835\uDEC5: " }), _jsx(FormikInput, { name: `signals.${index}.delta`, type: "number", placeholder: 'Delta (PPM)', style: style, checkErrorAfterInputTouched: false }), _jsx("span", { children: signal.js
                    .map((_coupling) => translateMultiplet(_coupling.multiplicity))
                    .join('') })] }));
}
